import React, { useState, useEffect } from 'react';
import CameraList from './components/CameraList';
import CameraViewer from './components/CameraViewer';
import Login from './components/Login';
import { isAuthenticated, clearAuth, getAuthUser } from './utils/auth';
import './App.css';

function App() {
  const [selectedCamera, setSelectedCamera] = useState(null);
  const [authenticated, setAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check authentication status on app load
  useEffect(() => {
    const checkAuth = () => {
      if (isAuthenticated()) {
        setAuthenticated(true);
        setUser(getAuthUser());
      } else {
        setAuthenticated(false);
        setUser(null);
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const handleCameraSelect = (camera) => {
    setSelectedCamera(camera);
  };

  const handleBackToList = () => {
    setSelectedCamera(null);
  };

  const handleLoginSuccess = (authData) => {
    setAuthenticated(true);
    setUser(authData.user);
  };

  const handleLogout = () => {
    clearAuth();
    setAuthenticated(false);
    setUser(null);
    setSelectedCamera(null);
  };

  // Global error handler for authentication errors
  const handleAuthError = () => {
    handleLogout();
  };

  if (loading) {
    return (
      <div className="App">
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          Loading...
        </div>
      </div>
    );
  }

  if (!authenticated) {
    return (
      <div className="App">
        <Login onLoginSuccess={handleLoginSuccess} />
      </div>
    );
  }

  return (
    <div className="App">
      <div className="app-header">
        <div className="user-info">
          Welcome, {user}
        </div>
        <button onClick={handleLogout} className="logout-button">
          Logout
        </button>
      </div>
      {selectedCamera ? (
        <CameraViewer 
          camera={selectedCamera} 
          onBack={handleBackToList}
          onAuthError={handleAuthError}
        />
      ) : (
        <CameraList 
          onCameraSelect={handleCameraSelect}
          onAuthError={handleAuthError}
        />
      )}
    </div>
  );
}

export default App; 